import { Navigate } from 'react-router-dom';

import ROUTES from '@/routes/routes';
import { clearCache } from '@/util/apollo/cache';
import TokenManager from '@/util/tokenManager';
import { isWeb } from '@/util/platform';
import { unidentify } from '@/util/vexo';

const Signout = () => {
  // Vexo: drop the session→user link first so the SDK has one tick to
  // flush before TokenManager + clearCache wipe in-memory state.
  unidentify();
  TokenManager.getInstance().cleanup();
  clearCache();
  if (isWeb()) {
    return <Navigate to={`/${ROUTES.login}`} />;
  } else {
    return <Navigate to={`/${ROUTES.appLogin}`} />;
  }
};

export default Signout;
